module.exports = __webpack_public_path__ + "static/media/german-time-table-2.bbe39fda.JPG";